import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { Toast } from '@capacitor/toast';

@Injectable({
  providedIn: 'root',
})
export class BasicSnackbarService {
  constructor(private _snackBar: MatSnackBar) {}

  open(message: string) {
    if (Capacitor.isNativePlatform()) {
      Haptics.impact({ style: ImpactStyle.Heavy }).then(() =>
        Toast.show({
          text: message,
          duration: 'short',
          position: 'top',
        })
      );
    } else {
      this._snackBar.open(message, '닫기', { duration: 5000 });
    }
  }
}

export function injectBasicSnackbarService() {
  return inject(BasicSnackbarService);
}
